import css from './dialog.module.scss';

import { memo, ReactNode } from 'react';

import useDialogHide from './useDialogHide';

type TProps = {
  children: ReactNode;
  isOpen: boolean;
  classname?: string;
  theme?: 'default';
};

const DELAY = parseInt(orDie(css.ANIM_DELAY), 10);

const Dialog: React.FC<TProps> = ({
  children,
  isOpen,
  classname = '',
  theme = 'default',
}) => {
  const { bodyRef, rootRef } = useDialogHide(isOpen, DELAY);

  return (
    <div
      className={css.root}
      data-theme={theme}
      ref={rootRef}
      data-open={isOpen}
    >
      <div className={css.overlay} data-open={isOpen} />
      {isOpen && (
        <div
          className={`${css.body} ${classname}`}
          data-open={isOpen}
          ref={bodyRef}
        >
          {children}
        </div>
      )}
      {/* fake clone done will be placed here */}
    </div>
  );
};

export default memo(Dialog);
